import { TitleSetterComponent } from './title-setter/title-setter.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainContentComponent } from './main-content/main-content.component';
import { MaterialModule } from './material.module';



@NgModule({
  declarations: [
    MainContentComponent,
    TitleSetterComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule
  ],
  exports: [
    MainContentComponent,
  ]
})
export class SharedModule { }
